/**
 * Mixin to help with Events.
 */
export default {

    computed: {
        availableEventClasses: function () {
            return [ 'Exhibition', 'Lecture', 'GuidedTour', 'Music', 'Workshop', 'OtherEvent' ];
        }
    },

    methods: {

        /**
         * Event period string.
         * If event is between 2000-01-01 – 2038-01-01 it is marked open permanently.
         */
        getEventPeriodString: function (item, formatOptions) {
            if (!item) {
                return '';
            }
            else {
                const start = item.Start;
                const end = item.End;
                let periodString = '';
                if (end?.match('2038-01-01')) {
                    periodString = this.$t('events.openPermanently');
                }
                else {
                    if (start) {
                        periodString += this.$helpers.toLocaleDateString(start, this.$i18n.locale, formatOptions);
                    }
                    if (end && start != end) { // eslint-disable-line eqeqeq
                        periodString += ' - ' + this.$helpers.toLocaleDateString(end, this.$i18n.locale, formatOptions);
                    }
                }
                return periodString;
            }
        },

        /**
         * Get the material-design icon associated with EventClass.
         */
        getEventClassIcon: function (eventClass) {
            switch (eventClass) {
            case 'Exhibition':
                return 'icon-octagram-outline';

            case 'Lecture':
                return 'icon-human-male-board';

            case 'GuidedTour':
                return 'icon-sign-direction';

            case 'Music':
                return 'icon-music';

            case 'Workshop':
                return 'icon-brush';

            case 'OtherEvent':
                return 'icon-cube-unfolded';

            default:
                return 'div';
            }
        },

        getEventClassColor: function (eventClass) {
            switch (eventClass) {
            case 'Exhibition':
                return '#d830e7';

            case 'Lecture':
                return '#123bd3';

            case 'GuidedTour':
                return '#0092d5';

            case 'Music':
                return '#f47f2f';

            case 'Workshop':
                return '#fa0023';

            case 'OtherEvent':
                return '#018b57';

            default:
                return '#aaa';
            }
        },

        /**
         * EventClass color.
         * Params:
         *     `eventClass`, eg. Exhibition, GuidedTour, ...
         *     `value`, selected value, eg. Music
         */
        getEventClassStyle: function (eventClass, value) {
            const selected = eventClass === value;
            const color = this.getEventClassColor(eventClass);
            if (!selected) {
                return `color: ${color}; border-color: ${color};`;
            }
            else {
                return `background-color: ${color}; border-color: ${color}; color: #f3f3f3;`;
            }
        }
    }
};
